import React from "react";
import { Flex } from "theme-ui";

interface Props {
  icon?: JSX.Element;
  title: string;
  text: string;
  reverse?: boolean;
  className?: string;
}

const IconCard = ({ reverse, icon, title, text, className }: Props) => {
  return (
    <Flex
      sx={{
        flexDirection: ["column"],
        justifyContent: "center",
        alignItems: "center",
        px: 3,
      }}
    >
      {icon ? (
        icon
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="199"
          height="199"
          viewBox="0 0 199 199"
          fill="none"
        >
          <circle cx="99.5" cy="99.5" r="99.5" fill="#DADEE5" />
        </svg>
      )}
      <Flex
        className={className}
        sx={{
          flexDirection: "column",
          maxWidth: 291,
          mx: 4,
          my: [4, null, null, 2],
        }}
      >
        <h2
          sx={{
            variant: "text.h2HeaderSemiBold",
            pb: 16,
            textAlign: "center",
          }}
        >
          {title}
        </h2>
        <p
          sx={{
            variant: "text.bodyNew",
            textAlign: "center",
            a: {
              textDecoration: "underline",
            },
          }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Flex>
    </Flex>
  );
};

export default IconCard;
